export const YA_MAP_URL = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=fa4c08b8-20d5-4a9e-861e-40af064738d5';
export const MAP_ID = 'map';
export const ZOOM_LEVEL = 17;
export const STROKE_COLOR = '#f60000';
export const STROKE_WIDTH = 5;
export const PLACE_MARK_ICON_COLOR = '#f60000';
export const PLACE_MARK_PRESET = 'islands#circleIcon'
